<template>
  <v-layout row wrap>
    <v-flex xs12>
      <CampoSelect
        id="empresaSelec"
        v-model="form.idempres"
        :items="empresas"
        texto="dsempres"
        valor="idempres"
        :onchange="changeHandler"
        label="Seleccione una empresa"
        placeholder=" "
      ></CampoSelect>
    </v-flex>
  </v-layout>
</template>

<script>
import { Label, CampoSelect } from '@/components';
import { notificarSuccess } from '@/utils/notification';
export default {
  name: 'SeleccionEmpresa',
  props: {
    empresas: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      form: {
        idempres: null
      }
    };
  },
  components: {
    Label,
    CampoSelect
  },
  methods: {
    changeHandler() {
      let empresa = this.empresas.filter(item => item.idempres === this.form.idempres)[0];
      this.$emit('changed', empresa);
      notificarSuccess(this, 'ok', 'Empresa seleccionada');
    }
  }
};
</script>
